import React from 'react';
import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';

const ScopeWrapper = styled.div`
  display: flex;
  width: 200px;
`;

const Scope = ({ text }) => {
  return (
    <ScopeWrapper>
      <EllipsisTooltip tooltipText={text}>{text}</EllipsisTooltip>
    </ScopeWrapper>
  );
};

export default React.memo(Scope);
